/*
 * @Author: jzh
 * @Date: 2020-11-17 17:04:33
 * @LastEditors: zxf
 * @LastEditTime: 2023-05-17 18:55:11
 * @Description: 单身份路由，主要修改查询接口
 */

import axios from 'axios';
import config from '@/config';
import { userService as us } from '@/features/system/attr/user/user.service.js';
const { iffApi } = config.ctx;
const commontCtx = config.commontCtx;

export {
  deptTree, // 查询机构部门树
  permissionDeptTree, // 根据用户查询权限部门树
  allDeptTree, // 查询所有机构部门树
  savePermission, // 保存权限
  getPositionList, // 获取职位列表
  getRoleList, // 获取部门岗位列表
  capacityService, // 身份服务
  roleCapacityService // 身份岗位关系服务
} from '@/features/system/attr/user/user.service.js';
export {
  attrUser // 查询机构部门树
} from '@/features/system/attr/attr.service.js';

const attrSingleUserQuery = (params) => { return axios.get(`${iffApi}/base/account/query`, { params }); };
// 切换组织接口
const singleUserChangeDept = (userCode, deptCode) => { return axios.post(`${commontCtx}/singleuser/change/${userCode}/${deptCode}`); };
const ccountSave = (fd) => { return axios.post(`${iffApi}/base/account/save`, fd); };

// 复用原有的userService对象，覆盖原有的query方法
export const userService = Object.assign({}, us, {
  query: attrSingleUserQuery,
  changeDept: singleUserChangeDept,
  save: ccountSave
});

export const accountService = {

  // 获取项目统计数量信息
  getXmNumber: (userCode) => { return axios.get(`${iffApi}/zhxf/tj/${userCode}`); },
  // 删除机构账号
  delAccountUser: (userCode) => { return axios.delete(`${iffApi}/base/account/delete/${userCode}`); },
  // 获取部门列表
  deptTree: (params) => { return axios.get(`${commontCtx}/dept/list`, { params: params }); }
};
